import { api } from './client'
import { withCustomerIds } from './params'

export function fetchDefenderSummary(customerIds = [], params = {}) {
  return api
    .get('/defender/summary', {
      params: withCustomerIds(params, customerIds),
    })
    .then((r) => r.data)
}

export function fetchDefenderDevices(params, customerIds = []) {
  return api
    .get('/defender/devices', { params: withCustomerIds(params, customerIds) })
    .then((r) => r.data)
}

export function fetchDefenderDetections(params, customerIds = []) {
  return api
    .get('/defender/detections', { params: withCustomerIds(params, customerIds) })
    .then((r) => r.data)
}
